import { render, staticRenderFns } from "./CrearCertificadoModal.vue?vue&type=template&id=138cf503&"
import script from "./CrearCertificadoModal.vue?vue&type=script&lang=ts&"
export * from "./CrearCertificadoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports